import React from 'react';
import { EditCategoryState } from './editCategoryState/EditCategoryState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const EditCategoryPageV2: React.FC = () => {
	return (
		<EditCategoryState>
			<Forms />
			<ModalWindows />
		</EditCategoryState>
	);
};
